import React, { useRef, useLayoutEffect, useState } from "react";
import { Link } from "react-router-dom";
import CurrentDeviceSize from "src/hooks/utils/currentDeviceSize";
import useFormatById from "src/hooks/utils/useFormatById";

const LinksGroup = ({ id, openedLinkGroups, data, isMobile }) => {
  const f = useFormatById();
  const [listHeight, setListHeight] = useState(0);
  const ulRef = useRef(null);

  // Calculate the height of the ul element once the component is mounted/updated
  useLayoutEffect(() => {
    if (
      ulRef.current &&
      openedLinkGroups &&
      openedLinkGroups.includes(id) &&
      isMobile
    ) {
      setListHeight(ulRef.current.scrollHeight);
    } else {
      setListHeight(0);
    }
  }, [openedLinkGroups, id, isMobile]);

  return (
    <ul ref={ulRef} style={{ height: isMobile ? listHeight : "auto" }}>
      {data?.map((link) => (
        <li key={link.id}>
          <Link to={link.href}>{f(link.text)}</Link>
        </li>
      ))}
    </ul>
  );
};

export default LinksGroup;
